
  var setQuickview = setInterval(function(){
    if( $ !== jQuery || jQuery == undefined ) {
      return;
    }

    clearInterval(setQuickview);

    $(".grid-view-item__quickview > button.quickview").hover(function(event) {
      if($(event.target).closest('.grid-view-item').find('.grid-view-item__image').length > 1) {
        $(event.target).closest('.grid-view-item').find('.grid-view-item__image.hover__image').css('z-index','0'); 
      }
    });

    $(".grid-view-item__quickview > button.quickview").on('click',function(event){ 
      console.log("Quickview clicked"); 
      event.preventDefault(); 
      var product_url = window.location.origin + '/products/' + $(this).attr('id') + '?view=quickviewnew'; 
      var _data = $.get(product_url); 
      console.log(_data); 
      console.log(_data['statusText']); 
      $.get(product_url, function(data) {
        $("#PopupQuickview > .quickview-container").empty();
        $("#PopupQuickview > .quickview-container").append(data); 

        $("#PopupQuickview").dialog({ 
            modal: true, 
            resizable: false, 
            draggable: false, 
            open: function() {
                if($(".ui-widget-overlay").length < 1) {
                  $("body").append("<div class='ui-widget-overlay ui-front'></div>");
                }
                $('.ui-widget-overlay').css("display",'block'); 
                $('.ui-widget-overlay').bind('click', function(event){
                $('#PopupQuickview').dialog('close');
              });
            }, 
            close: function() { 
              $('#PageContainer').removeAttr('style'); 
              $('#shopify-section-header').removeAttr('style');
            }  
          });

          $('#PopupQuickview .input-number-decrement').on('click', function(){
            var current_qty = $('#PopupQuickview #Quantity').val();
            if(current_qty != 1){
              current_qty--;
              $('#PopupQuickview #Quantity').val(current_qty);
            }
          });

          $('#PopupQuickview .input-number-increment').on('click', function(){
            var current_qty = $('#PopupQuickview #Quantity').val();
            current_qty++;
            $('#PopupQuickview #Quantity').val(current_qty);
          });

          if($('#product-price-range').length > 0 ) {
            $('#ProductPrice-quickview').html($('#product-price-range').html());
          }
          $('#PopupQuickview .single-option-selector').on('change',function(){
            var selected_option = $(this).find(':selected').index();
            if( selected_option != 0 ) {
              $('#ProductSelect option:eq('+(selected_option-1)+')').prop('selected', true);
              if($('#ProductJson-quickview').html().trim() != '' ) {
                var productJson = JSON.parse($('#ProductJson-quickview').html());
                var product_variant = productJson.variants[selected_option-1];

                if (product_variant.available && $('#meta-preorder').length != 0) {
                 $('#PopupQuickview .quantity-addtocart button[type="submit"]').removeAttr('disabled');
                 $('#AddToCartText-quickview').text(theme.strings.preOrder);
              } else {

                if( product_variant.available == true ) {
                  $('#PopupQuickview .quantity-addtocart button[type="submit"]').removeAttr('disabled');
                  $('#AddToCartText-quickview').html("Add to Cart");
                } else {
                  $('#PopupQuickview .quantity-addtocart button[type="submit"]').attr('disabled','disabled');
                  $('#AddToCartText-quickview').html("Sold Out");
                }
              }
                $('#ProductPrice-quickview').html('$'+(product_variant.price / 100));
              }
            } else {
              $('#PopupQuickview .quantity-addtocart button[type="submit"]').attr('disabled','disabled');
              $('#AddToCartText-quickview').html("Make a selection");

              if($('#product-price-range').length > 0 ) {
                $('#ProductPrice-quickview').html($('#product-price-range').html());
              }
            }
          });

          $('#PopupQuickview .thumbnails-wrapper .product-single__thumbnails-item').hover(function(event) {
            var image_src = $(this).find('img.product-single__thumbnail-image').attr('data-image-src');
            if(image_src != '' || image_src !== undefined ) {
              $('#PopupQuickview').find('.product-single-image').attr('src', image_src);
            }
          });


          $('#PopupQuickview > .quickview-container .product-single__photos > .thumbnails-wrapper .product-single__thumbnails-item').on('click', function(event) {
            event.preventDefault();
            return;
          });
   
          $("[data-include-content]").each(function() {
             var file = $(this).data('include-content');
             $(this).load(file);
          });
          
          var viewHeight = document.documentElement.height || window.innerHeight || 0;
          var dialog_height = $('*[role="dialog"]').height();
          var dialog_top = (viewHeight - dialog_height)/2;
          var dialog_top = Math.max(dialog_top, 40);
          $('*[role="dialog"]').css('top',dialog_top+'px');


          if($('#PopupQuickview #pr-reviewsnippet').length > 0){
            if( $('#PopupQuickview #pr-reviewsnippet').html().trim() == "") {
              var _sku = $('#PopupQuickview .product-quickview-sku').html().replace('SKU:&nbsp;','');
              if($('#pr-collectionsnippet-'+_sku).html().trim() != '') {
                $('#PopupQuickview #pr-reviewsnippet').html($('#pr-collectionsnippet-'+_sku).html());
              }
            }
          }
          
          $('#PopupQuickview .thumbnails-wrapper ul').slick({
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          });

          if($('#PopupQuickview .slick-next').length > 0 ) {
            $('#PopupQuickview .slick-next').click();
          }
          if($('#PopupQuickview .slick-prev').length > 0 ) {
            $('#PopupQuickview .slick-prev').click();
          }

          // Ajax Add to cart 
          var _config = {
            // What you might want to change
            addToCartBtnLabel:             'Add to cart',
            soldOutBtnLabel:               'Sold Out',
            howLongTillBtnReturnsToNormal: 1000, // in milliseconds.
            cartCountSelector:             '#CartCount,#minicart-items-count',
            cartTotalSelector:             '#cart-price',
            // 'aboveForm' for top of add to cart form, 
            // 'belowForm' for below the add to cart form, and 
            // 'nextButton' for next to add to cart button.
            feedbackPosition:              'nextButton',
            
            // What you will never need to change
            addToCartBtnSelector:          '[type="submit"]',
            addToCartFormSelector:         'form[action="/cart/add"]',
            shopifyAjaxAddURL:             '/cart/add.js',
            shopifyAjaxCartURL:            '/cart.js'
          };

          var setButtonText = function($button, label) {
            if ($button.children().length) {
              $button.children().each(function() {
                if ($.trim($(this).text()) !== '') {
                  $(this).text(label);
                }
              });
            }
            else {
              $button.val(label).text(label);
            }
          };

          $(_config.addToCartFormSelector).submit(function(e) {
            e.preventDefault();
            var $addToCartForm = $(this);
            var json_form = convertFormToJSONObjectWithMetafields($addToCartForm.serializeArray());
            var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
            $addToCartBtn.addClass('disabled').prop('disabled', true);
            // Add to cart.
            $.ajax({
              url: _config.shopifyAjaxAddURL,
              dataType: 'json',
              type: 'post',
              data: json_form,//$addToCartForm.serialize(),
              success: function(itemData) {
                // Re-enable add to cart button.
                $addToCartBtn.addClass('inverted');
                // _showFeedback('success','',$addToCartForm);
                window.setTimeout(function(){
                  $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
                }, _config.howLongTillBtnReturnsToNormal);
                // Update cart count and show cart link.
                $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
                  if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
                    var value = $(_config.cartCountSelector).html() || '0';
                    $(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
                  }
                  if (_config.cartTotalSelector && $(_config.cartTotalSelector).size()) {
                    if (typeof Currency !== 'undefined' && typeof Currency.moneyFormats !== 'undefined') {
                      var newCurrency = '';
                      if ($('[name="currencies"]').size()) {
                        newCurrency = $('[name="currencies"]').val();
                      }
                      else if ($('#currencies span.selected').size()) {
                        newCurrency = $('#currencies span.selected').attr('data-currency');
                      }
                      if (newCurrency) {
                        $(_config.cartTotalSelector).html('<span class=money>' + Shopify.formatMoney(Currency.convert(cart.total_price, shop_currency , newCurrency), Currency.money_format[newCurrency]) + '</span>');
                      } 
                      else {
                        $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, shop_money_format));
                      }
                    }
                    else {
                      $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price,shop_money_format));
                    }
                  };
                  $('#PopupQuickview').dialog('close');
                  $("html, body").animate({scrollTop: 0}, "slow");
                  document.getElementById('cart-icon-bubble').click();
                });        
              },
              error: function(XMLHttpRequest) {
                showErrorMessageDialog(XMLHttpRequest.responseJSON);
              }
            });   
            return false;    
          });
      }); 

    });

  },1000);
